import lockScroll from './lockScroll';
import {
  onKeyPressHandler
} from './utils';
import $ from 'jquery';
import TweenlineMax from 'gsap';

export default class Modal {
  constructor() {
    if (new.target === Modal) {
      throw new Error(`There is no opportunity to instantiate abstract class: Modal`);
    }
    this.page = document.querySelector(`.page`);
    this.logo = this.page.querySelector(`.logo`);
    this.menuButton = this.page.querySelector(`.page-header__menu`);
    this.wrapper = null;
    this.content = null;
    this.close = null;
    this.classNames = {
      MODAL: `modal`,
      MODAL_CONTENT: `modal__content`,
      MODAL_SHOWN: `modal--shown`,
      MODAL_CLOSE: `modal__close`,
      MODAL_NAVIGATION: `modal--navigation`
    };
  }

  createModal() {
    const wrapper = document.createElement(`div`);
    const content = document.createElement(`div`);
    const close = document.createElement(`div`);

    wrapper.className = this.classNames.MODAL;
    content.className = this.classNames.MODAL_CONTENT;
    close.className = this.classNames.MODAL_CLOSE;

    this.wrapper = wrapper;
    this.content = content;
    this.close = close;

    this.page.appendChild(wrapper);
    wrapper.appendChild(content);
    wrapper.appendChild(close);

    this.bind();
  };

  _toggleModal(isModalShown) {
    this.wrapper.classList.toggle(this.classNames.MODAL_SHOWN, isModalShown);
    lockScroll(isModalShown);
    var tl = new TimelineMax();
    if (isModalShown) {
      tl.to('.modal__close', 1, {
        opacity: 1
      }, '+=.3')
    } else {
      tl.to('.modal__close', 1, {
        opacity: 0
      })
    }
  };

  addLayout(elem) {
    this.content.innerHTML = elem;
  };

  bind() {
    this.close.addEventListener(`click`, () => {
      this._toggleModal(false);
      this.onClose();
    });

    this.logo.addEventListener(`click`, () => {
      this._toggleModal(false);
      this.onClose();
    });

    document.addEventListener(`keyup`, e => {
      onKeyPressHandler(e, 27, () => {
        this._toggleModal(false);
      })
    });
  };

  bindHandlers() {
    //set handlers in heirs
  }

  onClose() {
    //set handlers in heirs
  }
}
